import { safeParseJSON } from './safe-parse-json';
/**
 * Read settings for the given key.
 *
 * Given the key `foo` the settings are read either from the `data-foo-settings`
 * attribute on the document body element, or a data island with the id
 * `__FOO_SETTINGS__`.
 *
 * The settings are parsed as JSON.
 */

var read = function read(key) {
  var dataSetData = document.body.dataset[key];

  if (dataSetData) {
    return safeParseJSON(dataSetData);
  }

  var dataIslandKey = "__".concat(key.trim().replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase(), "__");
  var dataIslandElement = document.getElementById(dataIslandKey);

  if (dataIslandElement) {
    return safeParseJSON(dataIslandElement.innerHTML);
  }

  return null;
};
/**
 * Load settings.
 *
 * Supports multiple keys.
 */


export var getSettings = function getSettings(key) {
  if (!document.body || !key) {
    return null;
  }

  var keys = Array.isArray(key) ? key : [key];
  var settings;
  keys.some(function (k) {
    settings = read(k);
    return !!settings;
  });
  return settings;
};